import {
  OnInit,
  Component,
  ViewChild,
  AfterViewInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { CustomForms } from '../../../forms/custom-forms';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { WindowComponent } from 'movisat-common-gui';
import { SubflotaModel } from 'src/app/services/flota/models/subflota.model';
import { AppComponent } from 'src/app/app.component';
import { ResourcesService } from 'src/app/services/resources/resources.service';
import { MovilModel } from 'src/app/services/resources/models/movil.model';
import { RendererUtils } from 'src/app/utils/RendererUtils';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { Utils } from 'src/app/utils/utils';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { MainComponent } from '../../../main/main.component';
import { FlotaService } from 'src/app/services/flota/flota.service';
import { SsoService } from 'src/app/services/sso/sso.service';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-form-subflota',
  standalone: false,
  templateUrl: './form-subflota.component.html',
  styleUrl: './form-subflota.component.css',
})
export class FormSubflotaComponent
  extends CustomForms
  implements OnInit, OnChanges
{
  @ViewChild('ebNombre') protected ebNombre: jqxInputComponent;
  @ViewChild('formEdit') public formEdit: WindowComponent;
  @ViewChild('gridMoviles1') protected gridMoviles1: jqxGridComponent;
  @ViewChild('gridMoviles2') protected gridMoviles2: jqxGridComponent;
  @ViewChild('grid') protected grid: jqxGridComponent;

  @Input({ required: true }) protected subflotaEdit: SubflotaModel;

  @Input({ required: true }) protected movilesLibres: MovilModel[];

  @Output() protected subflotaEdited = new EventEmitter<SubflotaModel>();

  @Output() protected formClosed = new EventEmitter<void>();

  //parámetros
  public environment = environment;

  public subflotas: SubflotaModel[] = [];
  public subflotaSelec: SubflotaModel = new SubflotaModel();
  public subflotaResto: SubflotaModel = new SubflotaModel();

  public movilesResto: MovilModel[] = [];
  public movilesSubflota: MovilModel[] = [];
  public sourceMoviles1: any = [];
  public sourceMoviles2: any = [];
  public dataAdapterMoviles1;
  public dataAdapterMoviles2;

  public langGrid = JqWidgets.getLocalization('es'); // Pongo por defecto los textos en los controles del grid en español
  public canEdit = true;

  public constructor(
    private resourcesService: ResourcesService,
    private ssoService: SsoService,
    private flotaService: FlotaService,
    private modal: NzModalService
  ) {
    super();
  }

  protected actions = [
    {
      type: 'button',
      action: 'guardar',
      value: '',
      label: this.translate('Guardar'),
    },
    {
      type: 'button',
      action: 'salir',
      value: '',
      label: this.translate('Salir'),
    }
  ];
  public actionButtonClicked(event): void {
    if (event.action === 'salir') {
      this.onCancelBtn();
      return;
    }
    if (event.action === 'guardar') {
      this.onGuardarClick(event);
      return;
    }
  }

  protected onCancelBtn(): void {
    this.formEdit.closeWindow();
  }

  public ngOnInit(): void {
    this.canEdit = true;
    this.cargarGridAsignacion();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    for (const change in changes) {
      if (change === 'subflotaEdit') {
        this.subflotaEdit = changes[change].currentValue;
        return;
      }
      if (change === 'movilesLibres') {
        this.movilesLibres = changes[change].currentValue;
        return;
      }
    }
  }

  public async onOpenEditSubflota(): Promise<void> {
    const t = setTimeout(() => {
      clearTimeout(t);
      this.ebNombre.focus();
      this.cargarGridAsignacion();
      this.addCustomForm(this.formEdit);
    }, 0);
  }

  public async cargarGridAsignacion(): Promise<void> {
    try {
      // Recupero todos los móviles asignados a alguna subflota
      const movilesAsig = new Map<number, number>();
      if (this.subflotaEdit.MovilesId) {
        this.subflotaEdit.MovilesId.forEach((movil) => {
          movilesAsig.set(movil, movil);
        });
      }
      const result = await this.resourcesService.getMoviles();
      if (result) {
        this.movilesResto = this.movilesLibres;
        this.movilesSubflota = [];
        result.forEach((movil) => {
          if (movilesAsig.get(movil.Codigo)) {
            this.movilesSubflota.push(movil);
          }
        });
        // Actualizo la lista de móviles sin asignar
        this.sourceMoviles1 = {
          datatype: 'json',
          datafields: [
            { name: 'icono', map: 'ConjuntoVehiculo>Icono' },
            { name: 'codigo', map: 'Codigo', type: 'number' },
            { name: 'matricula', map: 'Matricula' },
            { name: 'nombre', map: 'Nombre' },
            { name: 'recurso', map: 'TipoMovil>Nombre' },
            { name: 'clase', map: 'clasesText' },
            { name: 'base', map: '' },
          ],
          localdata: this.movilesResto,
          sortcolumn: 'codigo',
          sortdirection: 'asc',
        };
        this.dataAdapterMoviles1 = new jqx.dataAdapter(this.sourceMoviles1);

        // Actualizo la lista de móviles asignados
        this.sourceMoviles2 = {
          datatype: 'json',
          datafields: [
            { name: 'icono', map: 'ConjuntoVehiculo>Icono' },
            { name: 'codigo', map: 'Codigo', type: 'number' },
            { name: 'matricula', map: 'Matricula' },
            { name: 'nombre', map: 'Nombre' },
            { name: 'recurso', map: 'TipoMovil>Nombre' },
            { name: 'clase', map: 'clasesText' },
            { name: 'base', map: '' },
          ],
          localdata: this.movilesSubflota,
          sortcolumn: 'codigo',
          sortdirection: 'asc',
        };
        this.dataAdapterMoviles2 = new jqx.dataAdapter(this.sourceMoviles2);
      }
    } catch (e) {
      console.error(e);
    }
  }

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  //hacer emit desde subflota con subflotaEdit
  public async onCloseEdit(): Promise<void> {
    this.formClosed.emit();
  }

  public createTooltip = (content: string) => {
    return (columnHeaderElement?: any) => {
      const jqElement = columnHeaderElement[0].parentElement;
      const options = {
        content: content,
        theme: environment.tema,
        width: 'auto',
        height: 'auto',
        position: 'mouse',
        autoHide: true,
      };
      return jqwidgets.createInstance(jqElement, 'jqxTooltip', options);
    };
  };

  public columnsMoviles = [
    {
      text: AppComponent.translate('Icono'),
      datafield: 'icono',
      cellsrenderer: this.rendeCell,
      rendered: this.createTooltip(AppComponent.translate('Icono')),
    },
    {
      text: AppComponent.translate('CODIGO'),
      datafield: 'codigo',
      cellsrenderer: RendererUtils.numberrenderer,
      rendered: this.createTooltip(AppComponent.translate('CODIGO')),
      aggregates: [
        {
          Total: function (aggregatedValue, currentValue: number) {
            return aggregatedValue + 1;
          },
        },
      ],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates['Total'] !== undefined) {
          renderstring =
            '<div style="text-align: left; margin-left: 4px;">' +
            AppComponent.translate('Total') +
            ': ' +
            aggregates['Total'] +
            ' </div>';
        }
        return renderstring;
      },
    },
    {
      text: AppComponent.translate('Matricula'),
      datafield: 'matricula',
      rendered: this.createTooltip(AppComponent.translate('Matricula')),
    },
    {
      text: AppComponent.translate('Nombre'),
      datafield: 'nombre',
      rendered: this.createTooltip(AppComponent.translate('Nombre')),
    },
    {
      text: AppComponent.translate('Recurso'),
      datafield: 'recurso',
      filtertype: 'checkedlist',
      rendered: this.createTooltip(AppComponent.translate('Recurso')),
    },
    {
      text: AppComponent.translate('Clase'),
      datafield: 'clase',
      rendered: this.createTooltip(AppComponent.translate('Clase')),
    },
    {
      text: AppComponent.translate('Base'),
      datafield: 'base',
      rendered: this.createTooltip(AppComponent.translate('Base')),
    },
  ];

  public rendeCell(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (columnfield === 'icono') {
      return `
            <img style="margin-left: 4px; margin-top: 6px;" height="16" width="16" src="data:image/jpg;base64,${value}"/>
          `;
    }
  }

  public filter(
    cellValue?: any,
    rowData?: any,
    dataField?: string,
    filterGroup?: any,
    defaultFilterResult?: boolean
  ): any {
    const filterColumns = ['nombre', 'observ'];
    return Utils.filterRow(
      cellValue,
      dataField,
      filterGroup,
      defaultFilterResult,
      filterColumns
    );
  }

  public updatefilterconditions = (
    type: string,
    defaultconditions: any
  ): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public onMenosClick(event: any): Promise<void> {
    if (!this.canEdit) {
      return;
    }
    const moviles = new Map<number, number>();
    const rowsSelec = this.gridMoviles2.getselectedrowindexes();
    if (rowsSelec.length > 0) {
      rowsSelec.forEach((rowIndex) => {
        this.movilesResto.push(this.movilesSubflota[rowIndex]);
        moviles.set(
          this.movilesSubflota[rowIndex].Codigo,
          this.movilesSubflota[rowIndex].Codigo
        );
      });
      for (let i = this.movilesSubflota.length - 1; i >= 0; i--) {
        if (moviles.get(this.movilesSubflota[i].Codigo)) {
          this.movilesSubflota.splice(i, 1);
        }
      }
      this.gridMoviles2.clearselection();
      this.gridMoviles1.updatebounddata('data');
      this.gridMoviles2.updatebounddata('data');
    }
  }

  public onMasClick(event: any): Promise<void> {
    if (!this.canEdit) {
      return;
    }
    const moviles = new Map<number, number>();
    const rowsSelec = this.gridMoviles1.getselectedrowindexes();
    if (rowsSelec.length > 0) {
      rowsSelec.forEach((rowIndex) => {
        this.movilesSubflota.push(this.movilesResto[rowIndex]);
        moviles.set(
          this.movilesResto[rowIndex].Codigo,
          this.movilesResto[rowIndex].Codigo
        );
      });
      for (let i = this.movilesResto.length - 1; i >= 0; i--) {
        if (moviles.get(this.movilesResto[i].Codigo)) {
          this.movilesResto.splice(i, 1);
        }
      }
      this.gridMoviles1.clearselection();
      this.gridMoviles1.updatebounddata('data');
      this.gridMoviles2.updatebounddata('data');
    }
  }

  public getEmptySubflota(): SubflotaModel {
    const subflota = new SubflotaModel();
    subflota.Id = 0;
    subflota.EmpresaId = this.ssoService.getTicket().Empresa.IdGestion;
    subflota.Nombre = '';
    subflota.Observaciones = '';
    subflota.MovilesId = [];
    return subflota;
  }

  public async saveSubflota(): Promise<void> {
    // Recupero los móviles no asignados a ninguna subflota
    if (this.movilesResto.length > 0) {
      const sfAux = this.getEmptySubflota();
      sfAux.Id = 0; // Para que se desasignen los móviles
      sfAux.MovilesId = [];
      this.movilesResto.forEach((movil) => {
        sfAux.MovilesId.push(movil.Codigo);
      });
      // Desasigno los móviles que no están en ninguna subflota
      await this.flotaService.setSubflotaMoviles(sfAux);
    }
    // Almaceno la subflota con todos los móviles asignados
    const result = await this.flotaService.saveSubflota(this.subflotaEdit);
    if (result) {
      if (this.subflotaEdit.Id === 0) {
        this.subflotas.push(result);
      } else {
        for (let i = 0; i < this.subflotas.length; i++) {
          if (this.subflotas[i].Id === this.subflotaEdit.Id) {
            this.subflotas[i] = { ...result };
            break;
          }
        }
      }
      this.subflotaEdit = { ...result };
      this.subflotaSelec = { ...this.subflotaEdit };
      MainComponent.getInstance().showSuccess(
        'ATENCION',
        'Registro_almacenado',
        2000
      );
      this.subflotaEdited.emit(this.subflotaEdit);
    } else {
      MainComponent.getInstance().showError(
        'ATENCION',
        'Fallo_almacenar_info',
        2000
      );
    }
    this.formEdit.closeWindow();
  }

  public async updateSubflotaResto(): Promise<void> {
    // Recupero todos los móviles
    const moviles = await this.resourcesService.getMoviles();
    // Recupero todos los móviles asignados a alguna subflota
    const movilesAsig = new Map<number, number>();
    if (this.subflotas) {
      this.subflotas.forEach((subflota) => {
        if (subflota.MovilesId && subflota.Id > 0) {
          // Los moviles de la flota resto no cuentan
          subflota.MovilesId.forEach((movil) => {
            movilesAsig.set(movil, movil);
          });
        }
      });
    }
    // Me quedo con los móviles que no están asignados
    this.subflotaResto.MovilesId = [];
    if (moviles) {
      moviles.forEach((movil) => {
        if (!movilesAsig.get(movil.Codigo)) {
          this.subflotaResto.MovilesId.push(movil.Codigo);
        }
      });
    }
  }

  public async onGuardarClick(event: any): Promise<void> {
    if (!this.canEdit) {
      return;
    }
    if (
      this.subflotaEdit.Nombre === null ||
      this.subflotaEdit.Nombre.length < 1
    ) {
      MainComponent.getInstance().showError(
        'ATENCION',
        'Introduzca_nombre',
        2000
      );
      return;
    }
    // Recupero los móviles asignados a la subflota
    this.subflotaEdit.MovilesId = [];
    if (this.movilesSubflota.length > 0) {
      this.movilesSubflota.forEach((movil) => {
        this.subflotaEdit.MovilesId.push(movil.Codigo);
      });
    }
    this.saveSubflota();
  }
}
